import script from "./HomePage.vue?vue&type=script&setup=true&lang=js"
export * from "./HomePage.vue?vue&type=script&setup=true&lang=js"

import "./HomePage.vue?vue&type=style&index=0&id=643d7740&lang=css"

const __exports__ = script;

export default __exports__